import { Component, Element, h, Host, Prop } from "@stencil/core";

/**
 *
 */
@Component({
  tag: "stzh-vbz-connection-finder",
  styleUrl: "stzh-vbz-connection-finder.scss",
  scoped: true,
})
export class StzhVbzConnectionFinder {
  /** Searchmask Script of ZVV */
  @Prop() zvvScript: string = "https://fpcdn.zvv.ch/cdn/v1/searchmask.min.js";

  @Element() element: HTMLStzhVbzConnectionFinderElement;

  private getIconPath(name: string) {
    return `${window.stzhComponents.pathMedia}/icons/mono/${name}.svg`;
  }

  render() {
    const classes = {
      "stzh-vbz-connection-finder": true,
    };

    return (
      <Host>
        <div class={classes}>
          <script src={this.zvvScript}></script>
          <div
            id="zvv-searchmask"
            data-draw-input-placeholder-outside="true"
            data-toggle-style-variant="inside"
            data-hide-refresh-button="true"
            data-background-color="#ffffff"
            data-accent-color="#ffffff"
            data-input-border-color="#7C7C7C"
            data-input-border-radius="0px"
            data-input-border-width="2px"
            data-input-placeholder-color="#034C67"
            data-input-text-color="#000000"
            data-button-color="#FFFFFF"
            data-button-background-color="#057FAC"
            data-button-hover-color="#ffffff"
            data-button-hover-background-color="#034C67"
            data-button-border-radius="0px"
            data-font-family="'HelveticaNeueLTW01_55Roman','Helvetica Neue','Helvetica,Arial',sans-serif;"
            data-calendar-icon={this.getIconPath("calendar")}
            data-info-icon={this.getIconPath("info-help")}
          ></div>
        </div>
      </Host>
    );
  }
}
